(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["doublee-detail-carousel"] && !Shopify.designMode) return;
  try {
    
function ddcInitViewport(vp) {
  if (vp.dataset.ddcReady === '1') return;
  vp.dataset.ddcReady = '1';
  var track = vp.querySelector('[data-ddc-track]');
  var prev = vp.querySelector('[data-ddc-prev]');
  var next = vp.querySelector('[data-ddc-next]');
  if (!track) return;

  function step() {
    var slide = track.querySelector('.ddc__slide');
    if (!slide) return 300;
    var cs = getComputedStyle(track);
    var gap = parseFloat(cs.columnGap || cs.gap) || 18;
    return slide.getBoundingClientRect().width + gap;
  }
  function sync() {
    if (!prev || !next) return;
    var max = track.scrollWidth - track.clientWidth - 2;
    prev.disabled = track.scrollLeft <= 2;
    next.disabled = track.scrollLeft >= max;
  }
  function scheduleSync() {
    requestAnimationFrame(function () { requestAnimationFrame(sync); });
    setTimeout(sync, 120);
  }
  if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
  if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
  track.addEventListener('scroll', sync, { passive: true });
  window.addEventListener('resize', sync);

  if (window.ResizeObserver) {
    var ro = new ResizeObserver(sync);
    ro.observe(track);
    track.querySelectorAll('.ddc__slide').forEach(function (s) { ro.observe(s); });
  }
  track.querySelectorAll('img').forEach(function (img) {
    if (!img.complete) img.addEventListener('load', sync, { once: true });
  });
  scheduleSync();
  setTimeout(sync, 400);
}
function ddcInitAll(scope) {
  (scope || document).querySelectorAll('[data-ddc-viewport]').forEach(ddcInitViewport);
}
document.addEventListener('DOMContentLoaded', function () { ddcInitAll(); });
document.addEventListener('shopify:section:load', function (e) { ddcInitAll(e.target); });
if (document.readyState !== 'loading') ddcInitAll();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class FooterMenu extends DetailsDisclosure {
      constructor() {
        super();
        this.reset(false);
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        const isConfirmNewsletter = !isLargeScreen &&
          (window.location.hash === "#footer-signup_form" && this.querySelector('#footer-signup_form') !== null);

        this.disclosure.open = isLargeScreen || isConfirmNewsletter;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }
    }

    customElements.define('footer-menu', FooterMenu);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class NavMenu extends DetailsDisclosure {
      constructor() {
        super();

        if(this.matches('.js-mega-nav')) {
          this.reset(false);
          window.addEventListener('on:breakpoint-change', this.reset.bind(this));
        }
      }

      reset(resize = true) {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        this.disclosure.open = isLargeScreen;
        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }

      handleToggle(e) {
        if (!(this.matches('.js-mega-nav') && window.matchMedia(theme.mediaQueries.md).matches)) {
          super.handleToggle(e);
        }
      }
    }

    customElements.define('nav-menu', NavMenu);
  });

  /**
   * Header CTA button that opens a menu panel instead of following a single link.
   * Falls back to native <details> behaviour when JS is unavailable.
   */
  class HeaderCta extends HTMLElement {
    constructor() {
      super();
      this.details = this.querySelector('details');
      this.toggle = this.querySelector('summary');
      this.hoverDelay = 120;
      this.leaveDelay = 220;
      this.scrollThreshold = 40;
      this.openScrollY = 0;
      this.openTimer = null;
      this.closeTimer = null;
      this.documentClickHandler = this.handleDocumentClick.bind(this);
      this.scrollHandler = this.handleScroll.bind(this);
    }

    connectedCallback() {
      if (!this.details || !this.toggle) return;

      this.addEventListener('keydown', this.handleKeydown.bind(this));
      this.addEventListener('focusout', this.handleFocusOut.bind(this));
      this.addEventListener('mouseenter', this.handleMouseEnter.bind(this));
      this.addEventListener('mouseleave', this.handleMouseLeave.bind(this));
      this.details.addEventListener('toggle', this.handleDetailsToggle.bind(this));
      document.addEventListener('click', this.documentClickHandler);
      window.addEventListener('scroll', this.scrollHandler, { passive: true });
    }

    disconnectedCallback() {
      document.removeEventListener('click', this.documentClickHandler);
      window.removeEventListener('scroll', this.scrollHandler);
      this.clearTimers();
    }

    /**
     * Hover only makes sense on the desktop header - in the mobile drawer the panel
     * is an inline accordion opened by tapping.
     * @returns {boolean}
     */
    get hoverEnabled() {
      return window.matchMedia('(hover: hover) and (pointer: fine)').matches
        && window.matchMedia('(min-width: 769px)').matches;
    }

    clearTimers() {
      if (this.openTimer) clearTimeout(this.openTimer);
      if (this.closeTimer) clearTimeout(this.closeTimer);
      this.openTimer = null;
      this.closeTimer = null;
    }

    handleMouseEnter() {
      if (!this.hoverEnabled) return;
      this.clearTimers();
      this.openTimer = setTimeout(() => { this.details.open = true; }, this.hoverDelay);
    }

    handleMouseLeave() {
      if (!this.hoverEnabled) return;
      this.clearTimers();
      this.closeTimer = setTimeout(() => { this.details.open = false; }, this.leaveDelay);
    }

    /**
     * Closes the panel on Escape, returning focus to the button.
     * @param {object} evt - Event object.
     */
    handleKeydown(evt) {
      if (evt.key !== 'Escape' || !this.details.open) return;
      this.details.open = false;
      this.toggle.focus();
    }

    handleFocusOut() {
      setTimeout(() => {
        if (this.details.open && !this.contains(document.activeElement)) {
          this.details.open = false;
        }
      }, 0);
    }

    /**
     * Closes the panel when clicking anywhere outside of it.
     * @param {object} evt - Event object.
     */
    handleDocumentClick(evt) {
      if (this.details.open && !this.contains(evt.target)) this.details.open = false;
    }

    handleDetailsToggle() {
      if (this.details.open) this.openScrollY = window.scrollY;
    }

    /**
     * Closes the panel once the page has scrolled away from where it was opened,
     * so the sticky header can collapse without the dropdown hanging around.
     */
    handleScroll() {
      if (!this.details.open) return;
      if (Math.abs(window.scrollY - this.openScrollY) > this.scrollThreshold) {
        this.details.open = false;
      }
    }
  }

  if (!customElements.get('header-cta')) {
    customElements.define('header-cta', HeaderCta);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-month"] && !Shopify.designMode) return;
  try {
    
  (function() {
    /* --- Scroll Animations --- */
    var observer = new IntersectionObserver(
      function(entries) {
        entries.forEach(function(entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
          }
        });
      },
      { threshold: 0.15, rootMargin: '0px 0px -50px 0px' }
    );

    document.querySelectorAll('.potm .potm-animate').forEach(function(el) {
      observer.observe(el);
    });

    /* --- Countdown Timer --- */
    var countdownEl = document.querySelector('.potm__countdown');
    if (!countdownEl) return;

    var endTimestamp = parseInt(countdownEl.getAttribute('data-end-timestamp'), 10) * 1000;
    var daysEl = countdownEl.querySelector('[data-potm-days]');
    var hoursEl = countdownEl.querySelector('[data-potm-hours]');
    var minutesEl = countdownEl.querySelector('[data-potm-minutes]');
    var secondsEl = countdownEl.querySelector('[data-potm-seconds]');
    var labelEl = countdownEl.querySelector('.potm__countdown-label');

    function updateCountdown() {
      var now = Date.now();
      var diff = endTimestamp - now;

      if (diff <= 0) {
        countdownEl.classList.add('potm__countdown--expired');
        labelEl.textContent = 'Kampanya sona erdi';
        return;
      }

      var days = Math.floor(diff / 86400000);
      var hours = Math.floor((diff % 86400000) / 3600000);
      var minutes = Math.floor((diff % 3600000) / 60000);
      var seconds = Math.floor((diff % 60000) / 1000);

      daysEl.textContent = days < 10 ? '0' + days : days;
      hoursEl.textContent = hours < 10 ? '0' + hours : hours;
      minutesEl.textContent = minutes < 10 ? '0' + minutes : minutes;
      secondsEl.textContent = seconds < 10 ? '0' + seconds : seconds;

      requestAnimationFrame(function() {
        setTimeout(updateCountdown, 1000);
      });
    }

    updateCountdown();

    /* --- Add to Cart --- */
    var form = document.getElementById('potm-atc-form');
    if (!form) return;

    var btn = form.querySelector('.potm__btn--primary');
    if (!btn) return;

    var originalLabel = btn.textContent.trim();

    form.addEventListener('submit', function(e) {
      e.preventDefault();
      if (btn.disabled) return;

      btn.disabled = true;
      btn.textContent = btn.dataset.loading || '...';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams(new FormData(form)).toString()
      })
        .then(function(res) {
          if (!res.ok) throw new Error('cart_error');
          return res.json();
        })
        .then(function() {
          btn.textContent = btn.dataset.added || '✓';
          document.dispatchEvent(new CustomEvent('cart:updated'));
          setTimeout(function() {
            btn.textContent = originalLabel;
            btn.disabled = false;
          }, 1800);
        })
        .catch(function() {
          btn.textContent = originalLabel;
          btn.disabled = false;
        });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-of-the-month"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var section = document.querySelector('.potm');
    if (!section) return;

    /* --- Scroll Animations --- */
    if (section.hasAttribute('data-potm-animate')) {
      var observer = new IntersectionObserver(
        function(entries) {
          entries.forEach(function(entry) {
            if (entry.isIntersecting) {
              entry.target.classList.add('is-visible');
            }
          });
        },
        { threshold: 0.15, rootMargin: '0px 0px -50px 0px' }
      );

      section.querySelectorAll('.potm-animate').forEach(function(el) {
        observer.observe(el);
      });
    }

    /* --- Force Autoplay Video --- */
    var video = section.querySelector('[data-potm-video]');
    if (video) {
      function forcePlay() {
        if (video.paused) {
          var p = video.play();
          if (p !== undefined) {
            p.catch(function() {
              video.muted = true;
              video.play().catch(function() {});
            });
          }
        }
      }

      forcePlay();

      var videoObserver = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
          if (entry.isIntersecting) {
            forcePlay();
          }
        });
      }, { threshold: 0.25 });

      videoObserver.observe(video);

      document.addEventListener('visibilitychange', function() {
        if (!document.hidden) forcePlay();
      });

      video.addEventListener('pause', function() {
        setTimeout(forcePlay, 100);
      });

      window.addEventListener('focus', forcePlay);

      document.addEventListener('touchstart', function touchPlay() {
        forcePlay();
        document.removeEventListener('touchstart', touchPlay);
      }, { once: true });
    }

    /* --- Button Shake (FOMO) --- */
    var shakeBtn = section.querySelector('[data-potm-shake]');
    if (shakeBtn) {
      setInterval(function() {
        if (!shakeBtn.disabled) {
          shakeBtn.classList.add('potm-shake-active');
          setTimeout(function() {
            shakeBtn.classList.remove('potm-shake-active');
          }, 700);
        }
      }, 4000);
    }

    /* --- Countdown Timer --- */
    var countdownEl = section.querySelector('.potm__countdown');
    if (countdownEl) {
      var endTimestamp = parseInt(countdownEl.getAttribute('data-end-timestamp'), 10) * 1000;
      var daysEl = countdownEl.querySelector('[data-potm-days]');
      var hoursEl = countdownEl.querySelector('[data-potm-hours]');
      var minutesEl = countdownEl.querySelector('[data-potm-minutes]');
      var secondsEl = countdownEl.querySelector('[data-potm-seconds]');
      var labelEl = countdownEl.querySelector('.potm__countdown-label');

      function updateCountdown() {
        var now = Date.now();
        var diff = endTimestamp - now;

        if (diff <= 0) {
          countdownEl.classList.add('potm__countdown--expired');
          labelEl.textContent = 'Kampanya sona erdi';
          return;
        }

        /* Countdown urgency mode */
        var hoursLeft = diff / 3600000;
        if (hoursLeft <= 1) {
          countdownEl.setAttribute('data-potm-urgency', 'final');
        } else if (hoursLeft <= 24) {
          countdownEl.setAttribute('data-potm-urgency', 'critical');
        } else if (hoursLeft <= 72) {
          countdownEl.setAttribute('data-potm-urgency', 'warning');
        } else {
          countdownEl.removeAttribute('data-potm-urgency');
        }

        var days = Math.floor(diff / 86400000);
        var hours = Math.floor((diff % 86400000) / 3600000);
        var minutes = Math.floor((diff % 3600000) / 60000);
        var seconds = Math.floor((diff % 60000) / 1000);

        daysEl.textContent = days < 10 ? '0' + days : days;
        hoursEl.textContent = hours < 10 ? '0' + hours : hours;
        minutesEl.textContent = minutes < 10 ? '0' + minutes : minutes;
        secondsEl.textContent = seconds < 10 ? '0' + seconds : seconds;

        requestAnimationFrame(function() {
          setTimeout(updateCountdown, 1000);
        });
      }

      updateCountdown();
    }

    /* --- Add to Cart --- */
    var form = section.querySelector('#potm-atc-form');
    if (form) {
      var btn = form.querySelector('.potm__btn--primary');
      if (btn) {
        var originalLabel = btn.textContent.trim();

        form.addEventListener('submit', function(e) {
          e.preventDefault();
          if (btn.disabled) return;

          btn.disabled = true;
          btn.textContent = btn.dataset.loading || '...';

          fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
            body: new URLSearchParams(new FormData(form)).toString()
          })
            .then(function(res) {
              if (!res.ok) throw new Error('cart_error');
              return res.json();
            })
            .then(function() {
              btn.textContent = btn.dataset.added || '✓';
              document.dispatchEvent(new CustomEvent('cart:updated'));
              setTimeout(function() {
                btn.textContent = originalLabel;
                btn.disabled = false;
              }, 1800);
            })
            .catch(function() {
              btn.textContent = originalLabel;
              btn.disabled = false;
            });
        });
      }
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wowi-mode-showcase"] && !Shopify.designMode) return;
  try {
    
(function () {
  if (!('IntersectionObserver' in window)) return;
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (en) {
      var v = en.target;
      if (en.isIntersecting) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
      else { v.pause(); }
    });
  }, { threshold: 0.25 });
  function boot(scope) {
    (scope || document).querySelectorAll('.wowi-ms video').forEach(function (v) {
      if (v.dataset.wmsInit) return;
      v.dataset.wmsInit = '1';
      io.observe(v);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(); }); else boot();
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();

  } catch(e) { console.error(e); }
})();
})();
